/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_No_File_SelectedInputs */

const vi_import_no_file_selected = /** @type {(inputs: Import_No_File_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa chọn file`)
};

/**

* @param {Import_No_File_SelectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_no_file_selected = /** @type {((inputs?: Import_No_File_SelectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_No_File_SelectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_no_file_selected(inputs)
});